<template>
    <table class="table2_default" v-if="isShow">
        <colgroup>
            <col style="width: 130px; max-width: 13px;"/>
            <col style="width: 250px; max-width: 250px;"/>
            <col style="width: 70px; max-width: 70px;"/>
            <col style="width: 170px; max-width: 170px;"/>
            <col style="width: 170px; max-width: 170px;"/>
            <col style="width: 150px; max-width: 150px;"/>
            <col style="width: 146px; max-width: 146px;"/>
        </colgroup>
        <thead>
            <tr>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_appointmentdate') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_patientname') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_class') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_groupname') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_staffname') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_programname') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_reservationstatus') }}</th>
            </tr>
        </thead>
        <ReservationPerUserCell 
            v-for="(r, index) in filteredReservation" :key="index"
            :reservation=r
        />
        <tr v-if="isNoResult">
            <td colspan="7" class="txt_center">{{ $t('reservationwindow.reservationmonitor.label_noappointments') }}</td>
        </tr>
    </table>
</template>


<script>
import { monitorState } from '../monitor-popup-state'

import ReservationPerUserCell from './ReservationPerUsersCell.vue'

export default {
    components: { ReservationPerUserCell },
    props: {
        filteredReservation: Array
    },
    data() {
        return {
            monitor: monitorState,
        }
    },
    watch: {

    },
    computed: {
        isShow: function() {
            return this.monitor.selectedPerType == 'users'
        },
        isNoResult: function() { return this.filteredReservation.length == 0 }
    }
}
</script>